import { Flex } from '@components';
import { styled } from '@mui/material';

export const StyledContainer = styled(Flex)(({ theme }) => ({
  marginTop: theme.spacing(10),
  flex: 1,
  flexDirection: 'row',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

export const StyledSliderContainer = styled(Flex)(({ theme }) => ({
  flexDirection: 'column',
  width: '25%',
  minWidth: 300,
  marginRight: theme.spacing(16),
  paddingBottom: theme.spacing(17),
  order: 1,
  [theme.breakpoints.down('md')]: {
    paddingBottom: theme.spacing(0),
    minWidth: 'auto',
    width: '100%',
    order: 2,
  },
}));

export const StyledChartContainer = styled(Flex)(({ theme }) => ({
  width: '100%',
  height: 'calc(100vw / 3.5)',
  paddingLeft: theme.spacing(10),
  order: 3,
  minWidth: 0,
  [theme.breakpoints.down('md')]: {
    order: 1,
    marginBottom: theme.spacing(18),
    paddingLeft: theme.spacing(0),
    height: 400,
  },
}));
